"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBidet = function SvgBidet(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.833h17.667V12.5H3.5zm6.167 8a.833.833 0 0 0-.834.834V20a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-.333a.833.833 0 0 0-.833-.834h-8zM4.594 12.81a8.346 8.346 0 0 0 7.998 5.96h2.616a5 5 0 0 0 5-5v-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 5.966C14.148 5.322 14.92 5 15.987 5c.962 0 1.623.542 1.983 1.626m-5.648 2.157C12.501 6.261 11.536 5 9.428 5c-.963 0-1.624.542-1.984 1.626",
    strokeDasharray: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBidet);
var _default = exports["default"] = Memo;